import { atom } from 'recoil'

import type { IntegrationsListState } from 'Pages/ImportLanding/model'

export const integrationsState = atom<IntegrationsListState>({
  key: 'recipientsImportIntegrationsState',
  default: {
    items: [],
    totalItems: 0,
    whiteLabel: false,
    ficStatus: undefined,
  },
})

export const importOptionsState = atom({
  key: 'recipientsImport_importOptionsState',
  default: [],
})

export const errorState = atom<boolean>({
  key: 'recipientsImportErrorState',
  default: false,
})
